/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

declare global {
    interface Window {
        isAddingToCart?: boolean;
    }
}

import * as React from 'react';
import { IWebgroupDirectoryExtendedProps } from './webgroup-directory';
import Msdyn365 from '@msdyn365-commerce/core';

export default (props: IWebgroupDirectoryExtendedProps) => {
    const {
        accordions,
        // emptyCartList,
        loaded,
        filterApplied,
        resources: { noMatchingProductsMsg, addToCartText },
        canAddToCart
    } = props;

    if (Msdyn365.isBrowser) {
        document.addEventListener('ADDED_TO_CART', () => {
            window.isAddingToCart = false;
        });
        document.addEventListener('ADDING_TO_CART', () => {
            const button = document.querySelector('.ms-cart-icon-wrapper') as HTMLButtonElement;
            button?.click();
        });
    }

    if (!loaded) {
        return (
            <div className='webgroups-directory-loading-skeleton'>
                <LoadingSkeleton />
            </div>
        );
    }

    return (
        <div className='webgroups-directory'>
            {filterApplied && accordions?.length === 0 && <h4>{noMatchingProductsMsg}</h4>}
            {accordions && accordions}
            {props.context.actionContext.requestContext.user.isAuthenticated ? (
                <div className='add-to-cart-bar fixed'>
                    <button
                        type='button'
                        className={`add-cart-button ${canAddToCart ? '' : 'disabled'}`}
                        disabled={!canAddToCart}
                        onClick={props.addMultipleToCart}
                    >
                        {addToCartText}
                    </button>
                </div>
            ) : (
                <></>
            )}
        </div>
    );
};

function LoadingSkeleton() {
    return (
        <div className='skeleton-container'>
            <div className='skeleton-container__layout'>
                <div className='skeleton-container__content'>
                    <div className='skeleton-container__table'>
                        {Array.from({ length: 4 }).map((_, i) => (
                            <div key={i} className='skeleton-container__table-row'>
                                <div className='skeleton skeleton--cell' />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
